<template>
  <div class="status-circle"
    :class="variants[variant]"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  name: "StatusIcon",
  props: {
    variant: {
      type: String,
      default: "yellow",
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      className: "status-y",
      variants: {
        yellow: "status-y",
        blue: "status-b",
        gray: "gray",
        red: "status-r",
      },
    };
  },
  created() {
  },
};
</script>
